import React from 'react'

const CountStateContext = React.createContext()
const CountDispatchContext = React.createContext()


const reducer = model => (state, action) => {
	console.log(action);
	let nextState = actualReducer(model,state,action);
	console.log(nextState);
	return nextState;
}
	
const actualReducer = (model,state,action) => {
	switch (action.type) {
		case 'balance': {
			let proportions = model.balanceProportions(state.proportions.slice(0));
			return {
				...state,
				proportions: proportions,
				forest: model.assessForest(state.treeIds,proportions)
			};
		}
		case 'setSmartBalance': {
			let proportions = model.balanceProportions(state.proportions.slice(0));
			return {
				...state,
				smartBalance: !!action.smartBalance,
				proportions: proportions,
				forest: model.assessForest(state.treeIds,proportions)
			};
		}
		case 'addTree': {
			let id = parseInt(action.treeId) || 0;
			if (id <= 0){
				throw new Error(`Invalid action property: treeId: ${id}`)
			}
			if(-1 < state.treeIds.indexOf(id)){
				throw new Error(`That treeId is already selected: ${id}`)
			}
			
			let proportions = state.proportions.concat([0]);
			if(state.proportions.length === 0 || state.smartBalance){
				proportions.fill(Math.floor(100/proportions.length));
				proportions = model.balanceProportions(proportions);
			}
			let treeIds = state.treeIds.concat([id]);
			return {
				...state,
				proportions: proportions,
				treeIds: treeIds,
				forest: model.assessForest(treeIds,proportions)
			};
		}
		case 'moveTree': {
			let fromIndex = parseInt(action.fromIndex);
			let toIndex = parseInt(action.toIndex);
			let treeIds = state.treeIds.slice(0);
			if (isNaN(fromIndex) || fromIndex < 0 || state.treeIds.length <= fromIndex){
				console.error(`Invalid action property: fromIndex: ${fromIndex} with threeIds.length: ${treeIds.length}`, state);
				return state;
			}
			if (isNaN(toIndex) || toIndex < 0 || state.treeIds.length <= toIndex){
				console.error(`Invalid action property: toIndex: ${toIndex} with threeIds.length: ${treeIds.length}`,state);
				return state;
			}
			let proportions = state.proportions.slice(0);
			console.log(`flipping ${treeIds[fromIndex]} and ${treeIds[toIndex]}`);
			if(fromIndex > toIndex){
				//moving up the list
			} else {
				//moving down the list
			}
			treeIds[toIndex] = state.treeIds[fromIndex];
			treeIds[fromIndex] = state.treeIds[toIndex];
			
			proportions[toIndex] = state.proportions[fromIndex];
			proportions[fromIndex] = state.proportions[toIndex];
			return {
				...state,
				proportions: proportions,
				treeIds: treeIds,
				forest: model.assessForest(treeIds,proportions)
			};
		}
		case 'removeAll': {
			return {
				...state,
				proportions: [],
				treeIds: [],
				forest: model.assessForest([],[])
			};
		}
		case 'removeTree': {
			let atIndex = parseInt(action.atIndex);
			if (isNaN(atIndex) || atIndex < 0 || state.treeIds.length <= atIndex){
				console.error(`Invalid action property: atIndex: ${atIndex}`)
				return state;
			}
			let proportions = state.proportions.slice(0);
			let treeIds = state.treeIds.slice(0);
			proportions.splice(atIndex,1);
			treeIds.splice(atIndex,1);
			if(treeIds.length === 1 || state.smartBalance){
				proportions = model.balanceProportions(proportions);
			}
			return {
				...state,
				proportions: proportions,
				treeIds: treeIds,
				forest: model.assessForest(treeIds,proportions)
			};
		}
		case 'setTreeProportion': {
			let atIndex = parseInt(action.atIndex) || 0;
			if (atIndex < 0 || state.treeIds.length <= atIndex){
				console.error(`Invalid action property: atIndex: ${atIndex}`)
				return state;
			}
			let proportion = parseInt(action.proportion) || 0;
			if (proportion < 0 || 100 < proportion){
				console.error(`Invalid action property: proportion: ${proportion}`)
				return state;
			}
			let proportions = state.proportions.slice(0);

			if(state.smartBalance){
				proportions = model.adjustProportions(
					proportions,
					atIndex,
					parseInt(proportion));
			} else {
				proportions[atIndex] = parseInt(proportion);
			}

			let treeIds = state.treeIds.slice(0);

			return {
				...state,
				proportions: proportions,
				forest: model.assessForest(treeIds,proportions)
			};
		}
		case 'increment': {
			return {...state, count: state.count + 1}
		}
		case 'decrement': {
			return {...state, count: state.count - 1}
		}
		case 'double': {
			return {...state, count: state.count * 2}
		}
		case 'half': {
			return {...state, count: state.count / 2}
		}
		case 'zero': {
			return {...state, count: 0}
		}
		default: {
			throw new Error(`Unhandled action type: ${action.type}`)
		}
	}
};
		
function ForestCompositionProvider({children,model}) {
const [state, dispatch] = React.useReducer(reducer(model), {treeIds: [], proportions: [], count: 0, smartBalance: false})
return (
	<CountStateContext.Provider value={state}>
	<CountDispatchContext.Provider value={dispatch}>
	{children}
	</CountDispatchContext.Provider>
	</CountStateContext.Provider>
	)
}

function useForestCompositionState() {
	const context = React.useContext(CountStateContext)
	if (context === undefined) {
		throw new Error('useForestCompositionState must be used within a CountProvider')
	}
	return context
}

function useForestCompositionDispatch() {
	const context = React.useContext(CountDispatchContext)
	if (context === undefined) {
		throw new Error('useForestCompositionDispatch must be used within a CountProvider')
	}
	return context
}
			
export {ForestCompositionProvider, useForestCompositionState, useForestCompositionDispatch};